import { Table, Tag, Typography } from "antd";
import GlassPanel from "../../components/common/glassPanel";

const { Text } = Typography;

const controls = [
  { key: "1", area: "Role access", owner: "Security", status: "Healthy", nextReview: "May 9" },
  { key: "2", area: "Supplier approvals", owner: "Operations", status: "Watch", nextReview: "May 5" },
  { key: "3", area: "Payout controls", owner: "Finance", status: "Critical", nextReview: "May 3" },
];

export default function GovernanceScreen() {
  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel eyebrow="Controls" title="Governance">
        <Text type="secondary">
          Internal approvals, policy checks, and audit surfaces stay common even when sector workflows differ.
        </Text>
      </GlassPanel>

      <GlassPanel title="Control Matrix">
        <Table
          rowKey="key"
          pagination={false}
          dataSource={controls}
          columns={[
            { title: "Area", dataIndex: "area" },
            { title: "Owner", dataIndex: "owner" },
            {
              title: "Status",
              dataIndex: "status",
              render: (value: string) => <Tag color={value === "Healthy" ? "success" : value === "Watch" ? "warning" : "error"}>{value}</Tag>,
            },
            { title: "Next Review", dataIndex: "nextReview" },
          ]}
        />
      </GlassPanel>
    </div>
  );
}
